import React, { Fragment, useContext } from 'react';
import { MainContext, MainContextProvider } from '@blaze-cms/nextjs-components';
import PropTypes from 'prop-types';
import uuid from 'uuid/v1';
import FullRenderItem from './FullRenderItem';
import ListPagination from '../Pagination';
import { LOAD_MORE } from '../../../../constants';
import { BANNER } from '../../constants';
import Wrapper from '../../../Wrapper';
import { checkIfShouldRenderBanner } from '../helpers';

const FullRender = ({
  orderedListData,
  omitWrappers,
  paginationType,
  graphqlEntityMap,
  ...props
}) => {
  const { parent, entity, propsToDisplay, banner, hasBanner } = props;

  const contextProps = useContext(MainContext);
  const pageBuilderID = uuid();
  const bannerProps = banner
    ? { hasBanner, parent, entity, propsToDisplay, ...banner, type: BANNER }
    : null;
  let bannerIndex = 0;
  const WrapperToUse = omitWrappers ? Fragment : Wrapper;

  return (
    <MainContextProvider value={{ ...contextProps, isPreview: false }}>
      <WrapperToUse className="list list--full">
        {orderedListData.map(({ id, __typename: dataEntity, ...entityProps }, i) => {
          const shouldRenderBanner = !!bannerProps && checkIfShouldRenderBanner(i, bannerProps);
          if (shouldRenderBanner) bannerIndex += 1;

          return (
            <FullRenderItem
              key={id}
              {...props}
              {...entityProps}
              entity={graphqlEntityMap[dataEntity]}
              index={i}
              itemId={id}
              pageBuilderID={pageBuilderID}
              entityProps={entityProps}
              shouldRenderBanner={shouldRenderBanner}
              bannerProps={bannerProps}
              bannerIndex={bannerIndex}
            />
          );
        })}
      </WrapperToUse>

      {paginationType === LOAD_MORE && (
        <ListPagination paginationType={paginationType} {...props} />
      )}
    </MainContextProvider>
  );
};

FullRender.propTypes = {
  orderedListData: PropTypes.array.isRequired,
  paginationType: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  propsToDisplay: PropTypes.array.isRequired,
  entity: PropTypes.string.isRequired,
  omitWrappers: PropTypes.bool,
  hasBanner: PropTypes.bool,
  banner: PropTypes.object,
  graphqlEntityMap: PropTypes.object.isRequired
};

FullRender.defaultProps = {
  omitWrappers: false,
  hasBanner: false,
  banner: null
};

export default FullRender;
